/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

import './DashboardCard.scss';

class DashboardCard extends React.PureComponent {
  handleRoute = ({ route, query }) => {
    const { onRoute } = this.props;
    onRoute({ route, query });
  };

  render() {
    const { title, icon, link, fill } = this.props;

    const getIcon = code => {
      switch (code) {
        case 'help':
          return <Icon name={code} fill={fill} />;
        case 'search':
          return <Icon name={code} fill={fill} />;
        case 'message':
          return <Icon name={code} fill={fill} />;
        case 'euro':
          return <Icon name={code} fill={fill} />;
        case 'contact':
          return <Icon name={code} fill={fill} />;

        default:
          return undefined;
      }
    };
    const core = () => (
      <>
        <div className="title" style={{ color: fill }}>
          {title}
        </div>
        <div className="button" style={{ color: fill }}>
          {link}
        </div>
      </>
    );

    return (
      <div className={`dlpk card ${icon}`}>
        <div className="icon">{getIcon(icon)}</div>
        <div className="core">{core()}</div>
      </div>
    );
  }
}
DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  fill: PropTypes.string,
};

DashboardCard.defaultProps = {
  fill: '#0d1d70',
};

export default DashboardCard;
